import React, { useState, useCallback, useRef, useEffect } from 'react';
import { Tooltip, Input } from 'antd';
import { useDrag, useDrop, DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend';
import update from 'immutability-helper';
import PropTypes from 'prop-types';
// import add from 'static/images/icons/Add_1.svg';
import { FormattedMessage } from 'react-intl';
import { LeftOutlined, RightOutlined, CheckOutlined } from '@ant-design/icons';
import { isMobileOnly } from 'react-device-detect';
import ScrollMenu from 'react-horizontal-scrolling-menu';
import { useSelector } from 'react-redux';
import withTranslations from 'app/components/HOGs/withTranslations';
import { deleteTourDay } from 'app/components/Utility/deleteTour';
import store from '../../../../store';
import { DownloadTourGpsProps } from '../../../../constants/PropType/propTypesDownloadTourGps';
import { fullDataProps } from '../../../../constants/PropType/propTypesFullData';
import { MapDataProps } from '../../../../constants/PropType/propTypesMapData';
import { PreviewPolyProps } from '../../../../constants/PropType/propTypesPreviewPoly';
import { RouterProps } from '../../../../constants/PropType/propTypesRouter';

import { DnDTabIcon, AddTabIcon } from '../../MainMenu/svg';
import { EditIcon, DeleteIcon } from './svg';
import {
  tourChangePartId,
  tourOpenedMultiPartAction,
  setActiveDayUpdate,
} from '../../../../actions/FullTour/full_tour_view.action';
import { showDeleteConfirm } from './deleteConfirm';

export const ItemTypes = {
  TAB: 'tab',
};

const ScrollItem = (props) => {
  const {
    id,
    item,
    text,
    index,
    addNewTourDay,
    fullData,
    setIsDragging,
    editTab,
    setEditTab,
  } = props;
  const { activeTourTab } = fullData;
  const { parts = [] } = fullData.data;
  const ref = useRef(null);
  const dropRef = useRef(null);

  const moveCard = useCallback(
    (dragIndex, hoverIndex) => {
      const dragCard = parts[dragIndex];
      const data = update(parts, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, dragCard],
        ],
      });
      // const dataToSave = [];
      const partsWithNewPartId = data.map((item) => {
        //   // dataToSave.push({
        //   //     id: item.id,
        //   //     part_id: i+1
        //   // })
        return item;
      });
      store.dispatch(tourChangePartId(partsWithNewPartId, hoverIndex + 1));
      store.dispatch(tourOpenedMultiPartAction(`${hoverIndex + 1}`));
      // tourPrevAPI.saveTourAfterTabDnd({parts: dataToSave});
    },
    [parts]
  );

  const [{ handlerId }, drop] = useDrop({
    accept: ItemTypes.TAB,
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    hover(item, monitor) {
      if (!dropRef.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }
      const hoverBoundingRect = dropRef.current?.getBoundingClientRect();
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      moveCard(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag, dragPreview] = useDrag({
    type: ItemTypes.TAB,
    item: () => {
      return { id, index };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  useEffect(() => {
    setIsDragging(isDragging);
  }, [isDragging]);

  const opacity = isDragging ? 0 : 1;

  drag(ref);
  drop(dropRef);
  dragPreview(dropRef);

  const keyValue = index + 1;

  return (
    <>
      <div
        className={+keyValue === +activeTourTab ? 'item active' : 'item'}
        key={keyValue}
        onClick={() => {
          if (editTab && +keyValue !== +activeTourTab) setEditTab(false);
          addNewTourDay(keyValue);
        }}
        style={{ opacity }}
        data-handler-id={handlerId}
        ref={dropRef}
        aria-hidden
      >
        {text}
        <ActiveIcons
          {...props}
          index={index}
          ref={ref}
          item={item}
          activeTourTab={activeTourTab}
        />
      </div>
      {/* <IconToAddPart {...props} index={index}/> */}
    </>
  );
};

const GetAddNewDayTab = ({
  addNewTourDay,
  index,
  open,
  setOpen,
  scrollToEnd = null,
}) => (
  <Tooltip
    placement="right"
    title={() => {
      return (
        <FormattedMessage
          id="Add additional part to the tour"
          defaultMessage="Add additional part to the tour"
        />
      );
    }}
    onMouseEnter={() => setOpen(true)}
    onMouseLeave={() => setOpen(false)}
    visible={open}
  >
    <div
      className="add_new"
      onClick={() => {
        addNewTourDay(index);
        setOpen(false);
        if (scrollToEnd) {
          scrollToEnd();
        }
      }}
      aria-hidden
    >
      <AddTabIcon width={18} height={18} />
    </div>
  </Tooltip>
);

const getTitle = (title, i, props) => {
  const { fullData, editTab, setEditTab, onChangeTitleTab, input, setInput } =
    props;
  return editTab && +fullData.activeTourTab === i + 1 ? (
    <Input
      size="small"
      value={input}
      onChange={(e) => setInput(e.target.value)}
      style={{ width: 70 }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      onPressEnter={() => {
        onChangeTitleTab(input);
        setEditTab(false);
      }}
    />
  ) : (
    <span>{title}</span>
  );
};

const Scroll = (props) => {
  const { edit, addNewTourDay, tabs, fullData, open, setOpen } = props;

  const ref = useRef(null);

  const [isDragging, setIsDragging] = useState(false);
  const [selected, setSelected] = useState(0);

  const scrollToEnd = () => {
    ref.current.scrollTo(ref.current.getNextItem('add'));
  };

  useEffect(() => {
    if (fullData.activeMultiPart.id) {
      setSelected(fullData.activeMultiPart.id);
    }
  }, [fullData.activeMultiPart]);

  const Arrow = ({ text, className }) => {
    return <div className={className}>{text}</div>;
  };

  const ArrowLeft = Arrow({
    text: <LeftOutlined style={{ fontSize: 30 }} />,
    className: 'arrow-prev',
  });
  const ArrowRight = Arrow({
    text: <RightOutlined style={{ fontSize: 30 }} />,
    className: 'arrow-next',
  });

  const Menu = (tabs = []) => {
    if (!tabs) return;

    const data = [...tabs];

    if (edit && data.filter((item) => item.id === 'add').length === 0) {
      data.push({ id: 'add' });
    }

    // eslint-disable-next-line consistent-return
    return data.map((item, i) => {
      return edit && item.id === 'add' ? (
        <GetAddNewDayTab
          key={item.id}
          addNewTourDay={addNewTourDay}
          index={tabs.length + 1}
          open={open}
          setOpen={setOpen}
          scrollToEnd={scrollToEnd}
        />
      ) : (
        <ScrollItem
          // eslint-disable-next-line react/no-array-index-key
          key={i}
          item={item}
          index={i}
          id={item.id}
          text={getTitle(item.title, i, props)}
          setIsDragging={setIsDragging}
          {...props}
        />
      );
    });
  };

  return (
    <div className="scroll">
      <div
        style={{ display: isDragging ? 'flex' : 'none' }}
        className="scroll_left_custom"
        onDragEnter={() => ref.current.handleArrowClick()}
      />
      <DndProvider backend={isMobileOnly ? TouchBackend : HTML5Backend}>
        <ScrollMenu
          data={Menu(tabs)}
          arrowLeft={ArrowLeft}
          arrowRight={ArrowRight}
          hideArrows
          hideSingleArrow={false}
          alignCenter={false}
          dragging={false}
          menuWidth="100%"
          scrollToSelected
          selected={selected}
          ref={ref}
        />
      </DndProvider>
      <div
        style={{ display: isDragging ? 'flex' : 'none' }}
        className="scroll_right_custom"
        onDragEnter={() => ref.current.handleArrowClickRight()}
      />
    </div>
  );
};

// const IconToAddPart = (props) => {
//   const { index, addNewTourDay, edit, fullData } = props;
//   const { parts = [] } = fullData.data;
//   return edit && parts && index !== parts.length - 1 && parts.length > 1 ? (
//     <div
//       className={index === -1 ? 'add_part_icon_all' : 'add_part_icon'}
//       onClick={(e) => {
//         e.stopPropagation();
//         addNewTourDay(`${index + 2}`, 'via_part');
//       }}
//     >
//       <Tooltip
//         placement="top"
//         title={(
//           <FormattedMessage
//             id="Add additional part to the tour"
//             defaultMessage="Add additional part to the tour"
//           />
//         )}
//       >
//         <img
//           src={add}
//           alt="Add additional part to the tour"
//           style={{ width: 13, height: 13, cursor: 'pointer' }}
//         />
//       </Tooltip>
//     </div>
//   ) : null;
// };

const ActiveIcons = React.forwardRef((props, ref) => {
  const {
    index,
    edit,
    tr,
    activeTourTab,
    editTab,
    setEditTab,
    deleteDay,
    setInput,
    onChangeTitleTab,
    item,
    input,
  } = props;

  const style =
    +activeTourTab - 1 === index ? { display: 'flex' } : { display: 'none' };

  return edit ? (
    <div style={style} className="tab_icons">
      {editTab ? (
        <Tooltip title={tr['Save title']}>
          <div
            onClick={() => {
              onChangeTitleTab(input);
              setEditTab(false);
            }}
            aria-hidden
          >
            <CheckOutlined style={{ fontSize: 17 }} />
          </div>
        </Tooltip>
      ) : (
        <Tooltip title={tr['Edit title']}>
          <div
            onClick={() => {
              setEditTab(true);
              setInput(item.title);
            }}
            aria-hidden
          >
            <EditIcon />
          </div>
        </Tooltip>
      )}
      <Tooltip title={tr.Delete}>
        <div className="deletePartIcon" onClick={() => deleteDay()} aria-hidden>
          <DeleteIcon />
        </div>
      </Tooltip>
      <Tooltip title={tr.Drag}>
        <div ref={ref}>
          <DnDTabIcon width="18px" />
        </div>
      </Tooltip>
    </div>
  ) : null;
});

const EditTabs = (props) => {
  const { addNewTourDay, tr, fullData } = props;
  const { parts = [] } = fullData.data;

  const [editTab, setEditTab] = useState(false);
  const [input, setInput] = useState('');
  const [open, setOpen] = useState(false);

  return (
    <div className="tour_tabs edit multiDayTabs">
      <div
        onClick={() => addNewTourDay('0')}
        className={+fullData.activeTourTab === 0 ? 'tabAll active' : 'tabAll'}
        aria-hidden
      >
        <div className="text">{parts.length > 1 ? tr.All : `${tr.Part} 1`}</div>
        {/* <IconToAddPart {...props} index={-1} /> */}
      </div>
      {parts.length > 1 ? (
        <Scroll
          {...props}
          editTab={editTab}
          setEditTab={setEditTab}
          input={input}
          setInput={setInput}
          open={open}
          setOpen={setOpen}
        />
      ) : (
        <GetAddNewDayTab
          addNewTourDay={addNewTourDay}
          index={parts.length + 1}
          open={open}
          setOpen={setOpen}
        />
      )}
    </div>
  );
};

const ViewTabs = (props) => {
  const { fullData, addNewTourDay, tr } = props;

  return (
    <div className="tour_tabs view multiDayTabs">
      <div
        onClick={() => addNewTourDay('0')}
        className={+fullData.activeTourTab === 0 ? 'tabAll active' : 'tabAll'}
        aria-hidden
      >
        <div className="text">{tr.All}</div>
      </div>
      <Scroll {...props} />
    </div>
  );
};

const getUrl = (location) => {
  const url = location ? location.pathname.split('/') : [];
  return url.splice(-1, 1, '');
};

const MultiDayTabs = (props) => {
  const { edit, tr } = props;

  const activeTourTab = useSelector(
    (store) => store.tourFullData.activeTourTab
  );

  const fullData = useSelector((state) => state.tourFullData);
  const multiDay = useSelector((store) => store.tourFullData.data.multiDay);
  const location = useSelector((store) => store.router.location);

  const id = useSelector((store) => store.tourFullData.data.id);
  const user = useSelector((store) => store.tourFullData.data.user);

  const { parts = [] } = fullData.data;

  const onChangeTitleTab = (str) => {
    const tourData = store.getState().tourFullData.activeMultiPart;
    if (!str && Object.keys(tourData).length === 0) return;
    tourData.title = str;
    store.dispatch(setActiveDayUpdate(tourData));
  };

  const deleteDay = () => {
    showDeleteConfirm(
      deleteTourDay,
      tr['Delete the day?'],
      tr,
      getUrl(location),
      {
        id,
        parts,
        user,
        multiDay,
      },
      activeTourTab
    );
  };

  if (!multiDay && !edit) {
    return null;
  }

  return edit && parts ? (
    <EditTabs
      {...props}
      tabs={parts}
      fullData={fullData}
      onChangeTitleTab={onChangeTitleTab}
      deleteDay={deleteDay}
    />
  ) : (
    <ViewTabs
      {...props}
      tabs={parts}
      fullData={fullData}
      onChangeTitleTab={onChangeTitleTab}
      deleteDay={deleteDay}
    />
  );
};

MultiDayTabs.propTypes = {
  TourDownloadBasketData: PropTypes.func,
  TourDownloadCoord: PropTypes.func,
  addNewTourDay: PropTypes.func,
  bookmark: PropTypes.object,
  chooseBookmark: PropTypes.func,
  deleteTourDay: PropTypes.func,
  desc: PropTypes.string,
  downloadTourGps: PropTypes.shape(DownloadTourGpsProps),
  edit: PropTypes.bool,
  editChoose: PropTypes.func,
  fullData: PropTypes.shape(fullDataProps),
  mapData: PropTypes.shape(MapDataProps),
  mapTourData: PropTypes.array,
  measureString: PropTypes.string,
  multiDayTabs: PropTypes.string,
  onChangeDesc: PropTypes.func,
  onChangeMultiDayTab: PropTypes.func,
  onChangeTitle: PropTypes.func,
  openModalTourDownload: PropTypes.func,
  prevPoly: PropTypes.shape(PreviewPolyProps),
  preview: PropTypes.object,
  ride: PropTypes.any,
  router: PropTypes.shape(RouterProps),
  title: PropTypes.string,
  tourData: PropTypes.object,
  tourPointDataAction: PropTypes.func,
};

export default withTranslations(MultiDayTabs);
